import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { MergedProjectDto } from "app/ApiClient";
import { EncodingVersionDto } from "app/SharedApiClient";

export interface CompareVersionState {
  referenceProject: Nullable<MergedProjectDto>;
  comparatorProject: Nullable<MergedProjectDto>;
  referenceEncodingVersions: EncodingVersionDto[];
  comparatorEncodingVersions: EncodingVersionDto[];
  compareResult: Nullable<{}>;
  referenceLoading: LoadingState;
  comparatorLoading: LoadingState;
  compareChangesLoading: LoadingState;
}
export const initialCompareVersionState: CompareVersionState = {
  referenceProject: null,
  comparatorProject: null,
  referenceEncodingVersions: [],
  comparatorEncodingVersions: [],
  comparatorLoading: LoadingState.idle,
  referenceLoading: LoadingState.idle,
  compareResult: null,
  compareChangesLoading: LoadingState.idle,
};
